module.exports = __webpack_public_path__ + "img/23.10.pH.1d8c1acc.png";